/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MarqCommonProtocolFileResponse,
  MonitoringCommonViewProtocolsExcelExportByListingIdRequest,
  MonitoringCommonViewProtocolsExcelExportRequest,
  MonitoringCommonViewProtocolsExcelExportResponse,
  MonitoringCommonViewProtocolsGetAllListingIdRequest,
  MonitoringCommonViewProtocolsGetAllListingIdResponse,
  MonitoringCommonViewProtocolsGetCountProgressRequest,
  MonitoringCommonViewProtocolsGetCountProgressResponse,
  MonitoringCommonViewProtocolsGetCountRequest,
  MonitoringCommonViewProtocolsGetCountResponse,
  MonitoringImageViewProtocolsGetGroupAllListingIdsRequest,
  MonitoringImageViewProtocolsGetGroupAllListingIdsResponse,
  MonitoringImageViewProtocolsGetGroupListingsRequest,
  MonitoringImageViewProtocolsGetGroupListingsResponse,
  MonitoringImageViewProtocolsGetImageGroupsRequest,
  MonitoringImageViewProtocolsGetImageGroupsResponse,
  MonitoringListViewProtocolsGetListingsRequest,
  MonitoringListViewProtocolsGetListingsResponse,
  MonitoringSellerViewProtocolsGetListingIdForSellerRequest,
  MonitoringSellerViewProtocolsGetListingIdForSellerResponse,
  MonitoringSellerViewProtocolsGetSellerDetailsRequest,
  MonitoringSellerViewProtocolsGetSellerDetailsResponse,
  MonitoringSellerViewProtocolsGetSellerListingsRequest,
  MonitoringSellerViewProtocolsGetSellerListingsResponse,
  MonitoringSellerViewProtocolsGetSellersRequest,
  MonitoringSellerViewProtocolsGetSellersResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class MonitoringDetected<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags MonitoringDetected
   * @name GetListingIdsCreate
   * @request POST:/monitoring/get-listing-ids
   */
  getListingIdsCreate = (data: MonitoringCommonViewProtocolsGetAllListingIdRequest, params: RequestParams = {}) =>
    this.http.request<MonitoringCommonViewProtocolsGetAllListingIdResponse, any>({
      path: `/monitoring/get-listing-ids`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringDetected
   * @name CountCreate
   * @request POST:/monitoring/count
   */
  countCreate = (data: MonitoringCommonViewProtocolsGetCountRequest, params: RequestParams = {}) =>
    this.http.request<MonitoringCommonViewProtocolsGetCountResponse, any>({
      path: `/monitoring/count`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringDetected
   * @name CountProgressCreate
   * @request POST:/monitoring/count/progress
   */
  countProgressCreate = (data: MonitoringCommonViewProtocolsGetCountProgressRequest, params: RequestParams = {}) =>
    this.http.request<MonitoringCommonViewProtocolsGetCountProgressResponse, any>({
      path: `/monitoring/count/progress`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringDetected
   * @name ExcelExportListingIdCreate
   * @request POST:/monitoring/excel/export/listing-id
   */
  excelExportListingIdCreate = (
    data: MonitoringCommonViewProtocolsExcelExportByListingIdRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MarqCommonProtocolFileResponse, any>({
      path: `/monitoring/excel/export/listing-id`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringDetected
   * @name ExcelExportCreate
   * @request POST:/monitoring/excel/export
   */
  excelExportCreate = (data: MonitoringCommonViewProtocolsExcelExportRequest, params: RequestParams = {}) =>
    this.http.request<MonitoringCommonViewProtocolsExcelExportResponse, any>({
      path: `/monitoring/excel/export`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringDetected
   * @name ListViewGetListingsCreate
   * @request POST:/monitoring/list-view/get-listings
   */
  listViewGetListingsCreate = (data: MonitoringListViewProtocolsGetListingsRequest, params: RequestParams = {}) =>
    this.http.request<MonitoringListViewProtocolsGetListingsResponse, any>({
      path: `/monitoring/list-view/get-listings`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringDetected
   * @name ImageViewGetGroupsCreate
   * @request POST:/monitoring/image-view/get-groups
   */
  imageViewGetGroupsCreate = (data: MonitoringImageViewProtocolsGetImageGroupsRequest, params: RequestParams = {}) =>
    this.http.request<MonitoringImageViewProtocolsGetImageGroupsResponse, any>({
      path: `/monitoring/image-view/get-groups`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringDetected
   * @name ImageViewGetListingsCreate
   * @request POST:/monitoring/image-view/get-listings
   */
  imageViewGetListingsCreate = (
    data: MonitoringImageViewProtocolsGetGroupListingsRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringImageViewProtocolsGetGroupListingsResponse, any>({
      path: `/monitoring/image-view/get-listings`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringDetected
   * @name ImageViewGetGroupListingIdsCreate
   * @request POST:/monitoring/image-view/get-group-listing-ids
   */
  imageViewGetGroupListingIdsCreate = (
    data: MonitoringImageViewProtocolsGetGroupAllListingIdsRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringImageViewProtocolsGetGroupAllListingIdsResponse, any>({
      path: `/monitoring/image-view/get-group-listing-ids`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringDetected
   * @name SellerViewGetSellersCreate
   * @request POST:/monitoring/seller-view/get-sellers
   */
  sellerViewGetSellersCreate = (data: MonitoringSellerViewProtocolsGetSellersRequest, params: RequestParams = {}) =>
    this.http.request<MonitoringSellerViewProtocolsGetSellersResponse, any>({
      path: `/monitoring/seller-view/get-sellers`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringDetected
   * @name SellerViewGetListingsCreate
   * @request POST:/monitoring/seller-view/get-listings
   */
  sellerViewGetListingsCreate = (
    data: MonitoringSellerViewProtocolsGetSellerListingsRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringSellerViewProtocolsGetSellerListingsResponse, any>({
      path: `/monitoring/seller-view/get-listings`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringDetected
   * @name SellerViewGetSellerListingIdsCreate
   * @request POST:/monitoring/seller-view/get-seller-listing-ids
   */
  sellerViewGetSellerListingIdsCreate = (
    data: MonitoringSellerViewProtocolsGetListingIdForSellerRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringSellerViewProtocolsGetListingIdForSellerResponse, any>({
      path: `/monitoring/seller-view/get-seller-listing-ids`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringDetected
   * @name SellerViewSellerDetailCreate
   * @request POST:/monitoring/seller-view/seller-detail
   */
  sellerViewSellerDetailCreate = (
    data: MonitoringSellerViewProtocolsGetSellerDetailsRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringSellerViewProtocolsGetSellerDetailsResponse, any>({
      path: `/monitoring/seller-view/seller-detail`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
